import { render, staticRenderFns } from "./send-contact-dialog.vue?vue&type=template&id=1cd64eda&scoped=true&"
import script from "./send-contact-dialog.vue?vue&type=script&lang=js&"
export * from "./send-contact-dialog.vue?vue&type=script&lang=js&"
import style0 from "./send-contact-dialog.vue?vue&type=style&index=0&id=1cd64eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd64eda",
  null
  
)

export default component.exports